module.exports = __webpack_public_path__ + "fonts/Gilroy-Regular.f6c9931.woff2";